var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useAuthProvider, useDependency } from '#context';
export const ProtectedRoute = ({ children, predicateFn, }) => {
    _react_refresh_temp_2();
    const isFirstVisitedScreenRef = useRef(true);
    const { currentUser, isLoadingCurrentUser } = useAuthProvider();
    const location = useLocation();
    const defaultRoute = useDependency('DEFAULT_ROUTE');
    useEffect(() => {
        if (isFirstVisitedScreenRef.current && !isLoadingCurrentUser) {
            isFirstVisitedScreenRef.current = false;
        }
    }, [isLoadingCurrentUser]);
    if (isLoadingCurrentUser) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Checking authentication status'), "data-testid": "checking-authentication-status", isFullHeight: true }) }));
    }
    const result = predicateFn({
        currentUser,
        defaultRoute,
        location,
    });
    const locationState = {
        navigatedFrom: isFirstVisitedScreenRef.current && !result.isSuccess
            ? result.navigatedFrom
            : undefined,
        ...location?.state,
        ...result.locationState,
    };
    if (result.isSuccess) {
        return children;
    }
    // "Forget" the 'navigatedFrom' as we are heading there already:
    if (result.navigateTo === locationState.navigatedFrom) {
        delete locationState['navigatedFrom'];
    }
    return _jsx(Navigate, { state: locationState, to: result.navigateTo });
};
_react_refresh_temp_1 = ProtectedRoute;
$RefreshReg$(_react_refresh_temp_1, "ProtectedRoute");
_react_refresh_temp_2(ProtectedRoute, "EzcQsMKoVT3DgsE4FqSGU5CW3pQ=", false, () => [useAuthProvider, useLocation, useDependency]);
